import { createBrowserRouter, Navigate } from "react-router-dom";

import PowerBiEmbedTestPage from "@/Components/PowerBiEmbedTestPage";
import AccessMatrixContainer from "@/features/AdminPortal/components/AccessMatrixContainer";

import ProtectedRoute from "../auth/ProtectedRoute";
import AuthLayout from "../layouts/AuthLayout";
import MainLayout from "../layouts/MainLayout";
import Dashboard from "../Pages/Dashboard";
import LoginPageWrapper from "../Pages/Login";
import Guarded from "./guarded";
import RouterRoot from "./routerRoute";

export const router = createBrowserRouter([
  {
    element: <RouterRoot />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          {
            element: <MainLayout />,
            children: [
              { path: "/", element: <Navigate to="/dashboard" replace /> },
              {
                path: "/dashboard",
                element: Guarded("/dashboard", <Dashboard />),
              },
              {
                path: "/powerbi",
                element: <PowerBiEmbedTestPage />,
              },
            ],
          },
        ],
      },
      {
        element: <AuthLayout />,
        children: [{ path: "/login", element: <LoginPageWrapper /> }],
      },
      {
        path: "/Admin-portal",
        element: <AccessMatrixContainer />,
      },
      {
        path: "/no-access",
        element: <div style={{ padding: 20 }}>You don’t have access to this page.</div>,
      },
      {
        path: "*",
        element: <div style={{ padding: 20 }}>Route not found</div>,
      },
    ],
  },
]);
